"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _filterNot = _interopRequireDefault(require("transmute/filterNot"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _ScopesContainer = _interopRequireDefault(require("crm_internal/containers/ScopesContainer"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _BETAssociationsMediator = require("crm_ui/BET/engagementAssociations/common/BETAssociationsMediator");

/*
  Adds BETs association support to an interaction component. Only scoped portals will
  be able to add or remove service associations.
*/
var InteractionWithBETAssociations = function InteractionWithBETAssociations(InteractionComponent) {
  var InteractionWithBETAssociationsComponent =
  /*#__PURE__*/
  function (_PureComponent) {
    (0, _inherits2.default)(InteractionWithBETAssociationsComponent, _PureComponent);

    function InteractionWithBETAssociationsComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithBETAssociationsComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithBETAssociationsComponent).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        BETPortalAssociations: (0, _immutable.List)(),
        BETServiceAssociations: (0, _immutable.List)()
      };
      return _this;
    }

    (0, _createClass2.default)(InteractionWithBETAssociationsComponent, [{
      key: "getBETProps",
      value: function getBETProps() {
        var betProps = {};

        if (_ScopesContainer.default.isScoped('bet-deliverable-service-association-access')) {
          betProps.BETServiceAssociations = this.state.BETServiceAssociations;
        }

        if (_ScopesContainer.default.isScoped('bet-portal-association-access')) {
          betProps.BETPortalAssociations = this.state.BETPortalAssociations;
        }

        if (Object.keys(betProps).length) {
          betProps.onAddBETAssociation = this.handleAddBETAssociation;
          betProps.onRemoveBETAssociation = this.handleRemoveBETAssociation;
          betProps.onSetBETAssociations = this.handleSetBETAssociations;
          betProps.onCreateEngagement = this.handleCreateEngagement;
          betProps.onReset = this.handleReset;
        }

        return (0, _extends2.default)({
          onCreateEngagement: _emptyFunction.default,
          onReset: _emptyFunction.default
        }, betProps);
      }
    }, {
      key: "handleCreateEngagement",
      value: function handleCreateEngagement(engagement) {
        var initialServiceAssociations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.List)();
        var initialPortalAssociations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.List)();
        var _this$state = this.state,
            BETPortalAssociations = _this$state.BETPortalAssociations,
            BETServiceAssociations = _this$state.BETServiceAssociations;

        if (BETPortalAssociations.size || initialPortalAssociations.size) {
          (0, _BETAssociationsMediator.updatePortalAssociations)(initialPortalAssociations, BETPortalAssociations, engagement.getIn(['engagement', 'id']));
          this.setState({
            BETPortalAssociations: (0, _immutable.List)()
          });
        }

        if (BETServiceAssociations.size || initialServiceAssociations.size) {
          (0, _BETAssociationsMediator.updateServiceAssociations)(initialServiceAssociations, BETServiceAssociations, engagement.getIn(['engagement', 'id']));
          this.setState({
            BETServiceAssociations: (0, _immutable.List)()
          });
        }
      }
    }, {
      key: "handleAddBETAssociation",
      value: function handleAddBETAssociation(associationType) {
        var _this2 = this;

        return function (value) {
          _this2.setState((0, _defineProperty2.default)({}, associationType, _this2.state[associationType].push(value)));
        };
      }
    }, {
      key: "handleRemoveBETAssociation",
      value: function handleRemoveBETAssociation(associationType) {
        var _this3 = this;

        return function (value) {
          var newAssociations = (0, _filterNot.default)(function (association) {
            return association.equals(value);
          }, _this3.state[associationType]);

          _this3.setState((0, _defineProperty2.default)({}, associationType, newAssociations));
        };
      }
    }, {
      key: "handleSetBETAssociations",
      value: function handleSetBETAssociations(associationType, associations) {
        this.setState((0, _defineProperty2.default)({}, associationType, associations));
      }
    }, {
      key: "handleReset",
      value: function handleReset() {
        this.setState({
          BETPortalAssociations: (0, _immutable.List)(),
          BETServiceAssociations: (0, _immutable.List)()
        });
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.getBETProps(), this.props));
      }
    }]);
    return InteractionWithBETAssociationsComponent;
  }(_PureComponent2.default);

  return InteractionWithBETAssociationsComponent;
};

var _default = InteractionWithBETAssociations;
exports.default = _default;
module.exports = exports.default;